import { render, staticRenderFns } from "./spampling_details.vue?vue&type=template&id=55675c8a&"
import script from "./spampling_details.vue?vue&type=script&lang=js&"
export * from "./spampling_details.vue?vue&type=script&lang=js&"
import style0 from "./spampling_details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports